/**
 * @desc 平台店铺
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<Array<defs.basics.PlatformShopsResponseDto>>;
export function request(
  body: defs.basics.PlatformShopsRequestPatamsDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/page`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
